import type { ImportQueueItem } from '@lib/import-queue-ui/types/import-queue-item';

import type { InsightsBulkImportQueueItem } from '../types/insights-bulk-import-queue-item';

export function insightsQueueItemToImportQueueItem(
  item: InsightsBulkImportQueueItem
): ImportQueueItem {
  const navigationId =
    item.status === 'done' && item.documentId ? item.documentId : undefined;
  return {
    clientId: item.clientId,
    fileName: item.file.name,
    relativePath: item.relativePath || item.file.name,
    status: item.status,
    errorMessage: item.errorMessage,
    navigationId,
  };
}
